import { convertSecondsToMinutedAndSecondsObject } from '@doltech/utils/lib/date';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { IconStopwatch } from '@doltech/icons-from-dev/IconStopwatch';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { flexGap } from '@doltech/utils/lib/css-style';
import cl from 'classnames';
import styled from 'styled-components';
import { size } from 'styled-system';
import { useTestSubmissionStore } from '../../model/test-submissions.hook';
import { sizeStyles } from '../ElementTestTimer/sizeStyles';
import { stateStyles } from '../ElementTestTimer/stateStyles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;

  ${sizeStyles}
  ${stateStyles}

  .time {
    display: flex;
    align-items: center;
    ${flexGap(8)}
  }
`;

export const ListeningTimeLimit = observer(() => {
  const testSubmissionStore = useTestSubmissionStore();
  const { remainTimeInSeconds } = testSubmissionStore;

  const time = convertSecondsToMinutedAndSecondsObject(remainTimeInSeconds);

  return (
    <Container className={cl('element-test-timer', size)}>
      <div className="time">
        <ResponsiveTypography.Text
          className="timer-text"
          variant="semi-bold/16-20"
          color="primary100"
        >
          {`${time.min}:${time.sec}`}
        </ResponsiveTypography.Text>
        <IconStopwatch fontSize={20} />
      </div>
    </Container>
  );
});
